// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content-1aBHrAS1","source":"source-WJ6kcpes","time":"time-34vT4Az8"};